// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .date-info__container {
    border: var(--space-half-quarter) solid var(--white-color);
    border-radius: 0 0 var(--space-half) var(--space-half);
}
*/

.league-tournament-report-dates__tabs .MuiTab-wrapper {
    text-transform: capitalize;
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + 1px);
    line-height: calc(var(--space) + var(--space-quarter));
    letter-spacing: 0.005em;
}
.league-tournament-report-dates__tabs .MuiTabs-flexContainer{
    border-bottom: none;
}

.league-tournament-report-dates {
    background: var(--white-color);
    padding: 10px;
}

.league-tournament-report-dates__accordion-item.MuiPaper-root.MuiAccordion-root {
    box-shadow: unset;
}

.league-tournament-report-dates__accordion-item.MuiPaper-root.MuiAccordion-root::before {
    height: 0;
}

.league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root {
    border-radius: 5px;
    border: 1px solid var(--new-gray-background-color);
    background: var(--new-light-gray-background-color);
    margin-bottom: 16px;
}

.league-tournament-report-dates__accordion-item:last-of-type .league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root {
    margin-bottom: 0;
}

.league-tournament-report-dates__accordion-item__summary .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {
    border-radius: 5px 5px 0 0;
    margin-bottom: 0;
    border: 0;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.league-tournament-report-dates__accordion-item.MuiPaper-root.MuiAccordion-root.Mui-expanded {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 5px;
    margin: 0 0 16px 0;
}

.league-tournament-report-dates__accordion-item .MuiAccordionDetails-root {
    padding: 12px;
}

.league-tournament-report-dates__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {
    border-radius: 5px;
    border: 1px solid var(--new-gray-background-color);
    background: var(--white-color);
    margin-bottom: 10px;
}

.league-tournament-report-dates__accordion-item-group.MuiPaper-root.MuiAccordion-root {
    box-shadow: unset;
}

.league-tournament-report-dates__accordion-item-group.MuiPaper-root.MuiAccordion-root::before {
    height: 0;
}

.league-tournament-report-dates__accordion-item-group:last-of-type .league-tournament-report-dates__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {
    margin-bottom: 0;
}

.league-tournament-report-dates__accordion-item-group__summary .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.league-tournament-report-dates__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {
    border-radius: 5px 5px 0 0;
    margin-bottom: 0;
    border: 0;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.league-tournament-report-dates__accordion-item-group.MuiPaper-root.MuiAccordion-root.Mui-expanded {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 5px;
}

.league-tournament-report-dates__accordion-item-group .MuiAccordionDetails-root {
    padding: 8px;
}

.calendar-info__container {
    border-radius: 0 0 var(--space-half) var(--space-half);
    border-top: var(--space-half-quarter) solid var(--white-color);
    border-left: var(--space-half-quarter) solid var(--white-color);
    border-right: var(--space-half-quarter) solid var(--white-color);
    padding-bottom: 12px;
}

.league-tournament-report-dates__container{
    text-align: center;
    padding: 10px;
    background: var(--white-color);
}

.league-tournament-report-dates__container.border {
    border-top: 1px solid var(--new-gray-background-color);
}

.league-tournament-report-dates__container .baloa-normal-medium {
    color: var(--primary-dark-color) ;
}
.league-tournament-report-dates__teams-container .icon-ball {
    color: var( --white-color );
    font-size: var( --space-and-half );
    border-radius: 50%;
    padding: var( --space-quarter );
    margin: 0 6px;
}

.league-tournament-report-dates__teams-container img {
    width: 30px;
    height: 30px;
    margin: 0px 6px;
}

.league-tournament-report-dates__teams-container {
    display: flex;
    align-items: center;
}

.league-tournament-report-dates__teams_local-container {
    /* text-align: right; */
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap:12px;
    width:44%;
}
.league-tournament-report-dates__teams_local-container:first-of-type{
    justify-content: flex-end;

}
.league-tournament-report-dates__teams_visitant-container {
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap:12px;
    width:44%;
}

.league-tournament-report-dates-score__teams-container{
    width: 12%;
    display: flex;
    justify-content: center;
}

.league-tournament-report-dates-score__teams-container .baloa-normal-medium{
    text-align: center;
}

.league-tournament-report-dates__teams-container div:first-of-type {
    display: flex;
    align-items: center;
    word-break: break-all;
    text-align: justify;
}


.league-tournament-report-dates__teams-container .baloa-names {
    color: var( --primary-very-dark-color );
    font-size: 18px;
    font-weight: 400;
    line-height: 21px;
}


.league-tournament-report-dates__teams-names-container {
    padding: 24px 16px;
    width: 100%;
    display:flex;
    justify-content: space-between;
    align-items: center;
}


.league-tournament-report-dates__teams-result-container {
    padding: calc(var(--space-quarter) + var(--space-eighth));
    text-align: start;
    display:flex;
    align-items: center;
    gap: 8px;
}

.league-tournament-report-dates__teams-result-container .baloa-table {

    white-space: nowrap;
}

.league-tournament-report-dates__teams-result-container .hubicon-finish_date:before{
    color: var(--primary-dark-color);
}

.league-tournament-report-dates__tabs{
    justify-content: space-between;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.league-tournament-report-dates__match-detail-container {
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border-radius: var(--space-half);
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.league-tournament-report-dates__teams-result-container .baloa-table.finalized {
    color: var( --white-color );
    background-color: #71847B;
    padding: 1px 4px;
    border-radius: 3px;
}

.league-tournament-report-dates__teams-result-container .baloa-icon {
    color: var(--primary-dark-color);
    white-space: nowrap;
    width: 10%;
}

.league-tournament-report-dates__group-title.baloa-hyperlink-2 {
    align-items: center;
    color: var( --primary-dark-color );
    margin-bottom: 12px;
    background-color: var(--white-color);
    padding: var(--space-half) var(--space);
    font-weight: var(--font-medium);
}

.league-tournament-report-dates__date-by-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border-radius: 8px;
    background: var(--new-background-color); 
    padding: 4px;
    gap: 8px;
}

.league-tournament-report-dates__group-title_container{
    padding: 12px 12px 0 12px;
}
.league-tournament-report-dates__teams-stadium-container{
    padding: 6px;
    text-align: start;
    display:flex;
    align-items: center;
    gap: 8px;
}
.league-tournament-report-dates__teams-stadium-container .baloa-table{
    color: var(--primary-very-dark-color)
}

.league-tournament-report-dates__teams-stadium-container .hubicon-stadium{
    color: var(--primary-dark-color);
}

.league-tournament-report-dates__match-info-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    background-color: var(--white-color);
    padding: 10px 16px;
    border-radius: var(--space-half) var(--space-half) 0 0;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.league-tournament-report-dates__match-detail-container_margin{
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border-radius: var(--space-half);
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.league-tournament-report-dates__date-by-group .view-more {
    background: var(--white-color);
    padding: 10px;
    grid-column-start: 1;
    grid-column-end: 3;
    display: flex;
    justify-content: center;
}

.league-tournament-report-dates__date-by-group .baloa-names.view-more {
    color: var(--new-green-color);
    cursor: pointer;
}

.league-tournament-report-dates__skeleton {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 5px;
    background: var(--white-color);
}

.league-tournament-report-dates__skeleton__match {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
}

.league-tournament-report-dates__skeleton__results {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 16px;
}

.league-tournament-report-dates__empty-message {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 230px;
    margin-left: auto;
    margin-right: auto;
    grid-column-start: 1;
    grid-column-end: 3;
    padding: 8px;
}

.league-tournament-report-dates__empty-message img{
    width: 210px;
}

.league-tournament-report-dates__empty-message .baloa-table-column {
    color: var(--primary-dark-color);
    text-align: center;
    margin-top: 15px;
}

.league-tournament-report-dates__date-by-group.hidden {
    display: none;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .league-tournament-report-dates__date-by-group {
        grid-template-columns:  1fr;
        padding: 0;
        gap: 0;
        border-radius: 5px;
        border: 1px solid var(--new-gray-background-color);
    }

    .league-tournament-report-dates__date-by-group .view-more {
        grid-column-end: 1;
        border-radius: 0 0 5px 5px;
    }

    .league-tournament-report-dates__accordion-item .MuiAccordionDetails-root {
        padding: 0;
    }

    .league-tournament-report-dates__match-detail-container {
        border: none;
        border-radius: 0;
        border-bottom: 1px solid var(--new-gray-background-color);
    }

    .league-tournament-report-dates__match-detail-container:last-of-type {
        border-bottom: 0;
        border-radius: 0 0 5px 5px;
    }

    .league-tournament-report-dates__match-info-container {
        border-bottom: none;
    }

    .league-tournament-report-dates__skeleton {
        border: none;
        border-bottom: 1px solid var(--new-gray-background-color);
        border-radius: 0;
    }

    .league-tournament-report-dates__skeleton:last-of-type {
        border-bottom: 0;
        border-radius: 0 0 5px 5px;
    }

    .league-tournament-report-dates__skeleton__match {
        padding: 8px;
    }

    .league-tournament-report-dates__skeleton__results {
        padding: 0 8px 8px 8px;
    }

    .league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root {
        min-height: unset;
        margin-bottom: 12px;
    }

    .league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {
        padding: 0 8px;
        min-height: unset;
    }

    .league-tournament-report-dates__accordion-item__summary .MuiAccordionSummary-content.Mui-expanded {
        margin: 8px 0;
    }

    .league-tournament-report-dates__accordion-item.MuiPaper-root.MuiAccordion-root.Mui-expanded {
        margin-bottom: 12px;
    }

    .league-tournament-report-dates__match-detail-container_margin {
        border-radius: 0;
        border: none;
        border-bottom: 1px solid var(--new-gray-background-color);  
    }

    .league-tournament-report-dates__match-detail-container_margin:last-of-type {
        border-bottom: none;
        border-radius: 0 0 5px 5px;
    }

    .league-tournament-report-dates__match-detail-container_margin:first-of-type {
        border-radius: 5px 5px 0 0;
    }

    .league-tournament-report-dates__accordion-item .league-tournament-report-dates__date-by-group {
        border: none;
    }

    .league-tournament-report-dates__teams-container .baloa-names {
        color: var( --primary-very-dark-color );
        font-size: 12px;
        font-weight: 500;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-tournament-report-dates-component/LeagueTournamentReportDatesComponent.styles.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,mCAAmC;IACnC,sDAAsD;IACtD,uBAAuB;AAC3B;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,yDAAyD;AAC7D;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,yDAAyD;AAC7D;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sDAAsD;IACtD,8DAA8D;IAC9D,+DAA+D;IAC/D,gEAAgE;IAChE,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,iCAAiC;AACrC;AACA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,SAAS;AACb;AACA;IACI,yBAAyB;;AAE7B;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;AACvB;;;AAGA;IACI,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;;;AAGA;IACI,yDAAyD;IACzD,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;IAChC,oCAAoC;IACpC,kDAAkD;AACtD;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,mBAAmB;IACnB,oCAAoC;IACpC,uCAAuC;IACvC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,sDAAsD;IACtD,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;IAChC,oCAAoC;IACpC,kDAAkD;AACtD;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,2BAA2B;QAC3B,UAAU;QACV,MAAM;QACN,kBAAkB;QAClB,kDAAkD;IACtD;;IAEA;QACI,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,yDAAyD;IAC7D;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,yDAAyD;QACzD,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,yDAAyD;IAC7D;;IAEA;QACI,mBAAmB;QACnB,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,uCAAuC;QACvC,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":["/* .date-info__container {\n    border: var(--space-half-quarter) solid var(--white-color);\n    border-radius: 0 0 var(--space-half) var(--space-half);\n}\n*/\n\n.league-tournament-report-dates__tabs .MuiTab-wrapper {\n    text-transform: capitalize;\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter));\n    letter-spacing: 0.005em;\n}\n.league-tournament-report-dates__tabs .MuiTabs-flexContainer{\n    border-bottom: none;\n}\n\n.league-tournament-report-dates {\n    background: var(--white-color);\n    padding: 10px;\n}\n\n.league-tournament-report-dates__accordion-item.MuiPaper-root.MuiAccordion-root {\n    box-shadow: unset;\n}\n\n.league-tournament-report-dates__accordion-item.MuiPaper-root.MuiAccordion-root::before {\n    height: 0;\n}\n\n.league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root {\n    border-radius: 5px;\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--new-light-gray-background-color);\n    margin-bottom: 16px;\n}\n\n.league-tournament-report-dates__accordion-item:last-of-type .league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root {\n    margin-bottom: 0;\n}\n\n.league-tournament-report-dates__accordion-item__summary .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {\n    border-radius: 5px 5px 0 0;\n    margin-bottom: 0;\n    border: 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.league-tournament-report-dates__accordion-item.MuiPaper-root.MuiAccordion-root.Mui-expanded {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 5px;\n    margin: 0 0 16px 0;\n}\n\n.league-tournament-report-dates__accordion-item .MuiAccordionDetails-root {\n    padding: 12px;\n}\n\n.league-tournament-report-dates__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {\n    border-radius: 5px;\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--white-color);\n    margin-bottom: 10px;\n}\n\n.league-tournament-report-dates__accordion-item-group.MuiPaper-root.MuiAccordion-root {\n    box-shadow: unset;\n}\n\n.league-tournament-report-dates__accordion-item-group.MuiPaper-root.MuiAccordion-root::before {\n    height: 0;\n}\n\n.league-tournament-report-dates__accordion-item-group:last-of-type .league-tournament-report-dates__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root {\n    margin-bottom: 0;\n}\n\n.league-tournament-report-dates__accordion-item-group__summary .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.league-tournament-report-dates__accordion-item-group__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {\n    border-radius: 5px 5px 0 0;\n    margin-bottom: 0;\n    border: 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.league-tournament-report-dates__accordion-item-group.MuiPaper-root.MuiAccordion-root.Mui-expanded {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 5px;\n}\n\n.league-tournament-report-dates__accordion-item-group .MuiAccordionDetails-root {\n    padding: 8px;\n}\n\n.calendar-info__container {\n    border-radius: 0 0 var(--space-half) var(--space-half);\n    border-top: var(--space-half-quarter) solid var(--white-color);\n    border-left: var(--space-half-quarter) solid var(--white-color);\n    border-right: var(--space-half-quarter) solid var(--white-color);\n    padding-bottom: 12px;\n}\n\n.league-tournament-report-dates__container{\n    text-align: center;\n    padding: 10px;\n    background: var(--white-color);\n}\n\n.league-tournament-report-dates__container.border {\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.league-tournament-report-dates__container .baloa-normal-medium {\n    color: var(--primary-dark-color) ;\n}\n.league-tournament-report-dates__teams-container .icon-ball {\n    color: var( --white-color );\n    font-size: var( --space-and-half );\n    border-radius: 50%;\n    padding: var( --space-quarter );\n    margin: 0 6px;\n}\n\n.league-tournament-report-dates__teams-container img {\n    width: 30px;\n    height: 30px;\n    margin: 0px 6px;\n}\n\n.league-tournament-report-dates__teams-container {\n    display: flex;\n    align-items: center;\n}\n\n.league-tournament-report-dates__teams_local-container {\n    /* text-align: right; */\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap:12px;\n    width:44%;\n}\n.league-tournament-report-dates__teams_local-container:first-of-type{\n    justify-content: flex-end;\n\n}\n.league-tournament-report-dates__teams_visitant-container {\n    text-align: right;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap:12px;\n    width:44%;\n}\n\n.league-tournament-report-dates-score__teams-container{\n    width: 12%;\n    display: flex;\n    justify-content: center;\n}\n\n.league-tournament-report-dates-score__teams-container .baloa-normal-medium{\n    text-align: center;\n}\n\n.league-tournament-report-dates__teams-container div:first-of-type {\n    display: flex;\n    align-items: center;\n    word-break: break-all;\n    text-align: justify;\n}\n\n\n.league-tournament-report-dates__teams-container .baloa-names {\n    color: var( --primary-very-dark-color );\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 21px;\n}\n\n\n.league-tournament-report-dates__teams-names-container {\n    padding: 24px 16px;\n    width: 100%;\n    display:flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n\n.league-tournament-report-dates__teams-result-container {\n    padding: calc(var(--space-quarter) + var(--space-eighth));\n    text-align: start;\n    display:flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.league-tournament-report-dates__teams-result-container .baloa-table {\n\n    white-space: nowrap;\n}\n\n.league-tournament-report-dates__teams-result-container .hubicon-finish_date:before{\n    color: var(--primary-dark-color);\n}\n\n.league-tournament-report-dates__tabs{\n    justify-content: space-between;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.league-tournament-report-dates__match-detail-container {\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    border-radius: var(--space-half);\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.league-tournament-report-dates__teams-result-container .baloa-table.finalized {\n    color: var( --white-color );\n    background-color: #71847B;\n    padding: 1px 4px;\n    border-radius: 3px;\n}\n\n.league-tournament-report-dates__teams-result-container .baloa-icon {\n    color: var(--primary-dark-color);\n    white-space: nowrap;\n    width: 10%;\n}\n\n.league-tournament-report-dates__group-title.baloa-hyperlink-2 {\n    align-items: center;\n    color: var( --primary-dark-color );\n    margin-bottom: 12px;\n    background-color: var(--white-color);\n    padding: var(--space-half) var(--space);\n    font-weight: var(--font-medium);\n}\n\n.league-tournament-report-dates__date-by-group {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    border-radius: 8px;\n    background: var(--new-background-color); \n    padding: 4px;\n    gap: 8px;\n}\n\n.league-tournament-report-dates__group-title_container{\n    padding: 12px 12px 0 12px;\n}\n.league-tournament-report-dates__teams-stadium-container{\n    padding: 6px;\n    text-align: start;\n    display:flex;\n    align-items: center;\n    gap: 8px;\n}\n.league-tournament-report-dates__teams-stadium-container .baloa-table{\n    color: var(--primary-very-dark-color)\n}\n\n.league-tournament-report-dates__teams-stadium-container .hubicon-stadium{\n    color: var(--primary-dark-color);\n}\n\n.league-tournament-report-dates__match-info-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    background-color: var(--white-color);\n    padding: 10px 16px;\n    border-radius: var(--space-half) var(--space-half) 0 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.league-tournament-report-dates__match-detail-container_margin{\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    border-radius: var(--space-half);\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.league-tournament-report-dates__date-by-group .view-more {\n    background: var(--white-color);\n    padding: 10px;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    display: flex;\n    justify-content: center;\n}\n\n.league-tournament-report-dates__date-by-group .baloa-names.view-more {\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.league-tournament-report-dates__skeleton {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 5px;\n    background: var(--white-color);\n}\n\n.league-tournament-report-dates__skeleton__match {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 16px;\n}\n\n.league-tournament-report-dates__skeleton__results {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 16px;\n}\n\n.league-tournament-report-dates__empty-message {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    width: 230px;\n    margin-left: auto;\n    margin-right: auto;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    padding: 8px;\n}\n\n.league-tournament-report-dates__empty-message img{\n    width: 210px;\n}\n\n.league-tournament-report-dates__empty-message .baloa-table-column {\n    color: var(--primary-dark-color);\n    text-align: center;\n    margin-top: 15px;\n}\n\n.league-tournament-report-dates__date-by-group.hidden {\n    display: none;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .league-tournament-report-dates__date-by-group {\n        grid-template-columns:  1fr;\n        padding: 0;\n        gap: 0;\n        border-radius: 5px;\n        border: 1px solid var(--new-gray-background-color);\n    }\n\n    .league-tournament-report-dates__date-by-group .view-more {\n        grid-column-end: 1;\n        border-radius: 0 0 5px 5px;\n    }\n\n    .league-tournament-report-dates__accordion-item .MuiAccordionDetails-root {\n        padding: 0;\n    }\n\n    .league-tournament-report-dates__match-detail-container {\n        border: none;\n        border-radius: 0;\n        border-bottom: 1px solid var(--new-gray-background-color);\n    }\n\n    .league-tournament-report-dates__match-detail-container:last-of-type {\n        border-bottom: 0;\n        border-radius: 0 0 5px 5px;\n    }\n\n    .league-tournament-report-dates__match-info-container {\n        border-bottom: none;\n    }\n\n    .league-tournament-report-dates__skeleton {\n        border: none;\n        border-bottom: 1px solid var(--new-gray-background-color);\n        border-radius: 0;\n    }\n\n    .league-tournament-report-dates__skeleton:last-of-type {\n        border-bottom: 0;\n        border-radius: 0 0 5px 5px;\n    }\n\n    .league-tournament-report-dates__skeleton__match {\n        padding: 8px;\n    }\n\n    .league-tournament-report-dates__skeleton__results {\n        padding: 0 8px 8px 8px;\n    }\n\n    .league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root {\n        min-height: unset;\n        margin-bottom: 12px;\n    }\n\n    .league-tournament-report-dates__accordion-item__summary.MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded {\n        padding: 0 8px;\n        min-height: unset;\n    }\n\n    .league-tournament-report-dates__accordion-item__summary .MuiAccordionSummary-content.Mui-expanded {\n        margin: 8px 0;\n    }\n\n    .league-tournament-report-dates__accordion-item.MuiPaper-root.MuiAccordion-root.Mui-expanded {\n        margin-bottom: 12px;\n    }\n\n    .league-tournament-report-dates__match-detail-container_margin {\n        border-radius: 0;\n        border: none;\n        border-bottom: 1px solid var(--new-gray-background-color);  \n    }\n\n    .league-tournament-report-dates__match-detail-container_margin:last-of-type {\n        border-bottom: none;\n        border-radius: 0 0 5px 5px;\n    }\n\n    .league-tournament-report-dates__match-detail-container_margin:first-of-type {\n        border-radius: 5px 5px 0 0;\n    }\n\n    .league-tournament-report-dates__accordion-item .league-tournament-report-dates__date-by-group {\n        border: none;\n    }\n\n    .league-tournament-report-dates__teams-container .baloa-names {\n        color: var( --primary-very-dark-color );\n        font-size: 12px;\n        font-weight: 500;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
